/* ---------------------------------- */
/*  共通コード(名称マスタ定義マスタ)  */
/* ---------------------------------- */

// 税区分
export const GC_H0001_TAX_CATEGORY = "0001";
// 混在許可区分
export const GC_H0002_MIXING_PERMISSION = "0002";
// バイヤー区分
export const GC_H0003_BUYER_TYPE = "0003";
// 原価割れチェック区分
export const GC_H0004_PRICE_BREAK_CHECK = "0004";
// 発注可否
export const GC_H0010_ORDER_FLAG = "0010";
// 店舗区分
export const GC_H0011_STORE_TYPE = "0011";
// 店舗営業区分
export const GC_H0012_STORE_OP_TYPE = "0012";
// 店舗業態区分
export const GC_H0013_STORE_FORMAT_TYPE = "0013";
// 自動発注区分
export const GC_H0014_AUTO_ORDER_TYPE = "0014";
// POS機種
export const GC_H0015_POS_MODEL = "0015";
// POS配信区分
export const GC_H0016_POS_DELIVERY_TYPE = "0016";
// 店舗種別
export const GC_H0018_STORE_CATEGORY = "0018";
// 休日タイプ
export const GC_H0019_CLOSED_DAY_TYPE = "0019";
// 仕入形態区分
export const GC_H0020_PURCHASE_MODE_TYPE = "0020";
// 事業者税区分
export const GC_H0021_BUSINESS_TAX_TYPE = "0021";
// 締め対象月度区分
export const GC_H0022_CLOSE_TARGET_MTH_TYPE = "0022";
// 月度判定基準区分
export const GC_H0023_MONTH_BASE_RULE_TYPE = "0023";
// 名称マスタ使用区分
export const GC_H0024_CC_USAGE_FLAG = "0024";
// 取引停止区分
export const GC_H0025_TRADE_STOP_TYPE = "0025";
// 仕入税端数処理単位
export const GC_H0026_PUR_TAX_RND_UNIT = "0026";
// 端数処理区分
export const GC_H0027_AMT_RND_MTHD = "0027";
// 発注方法
export const GC_H0028_ORDER_METHOD = "0028";
// 本部更新権限区分
export const GC_H0029_HQ_UPDATE_PRIV_FLG = "0029";
// システム管理者権限区分
export const GC_H0030_SYS_ADMIN_PRIV_FLG = "0030";
// ユーザー使用可否区分
export const GC_H0031_USER_ACTIVE_FLG = "0031";
// 支払サイト
export const GC_H0032_PAYMENT_TERM = "0032";
// 納品経路
export const GC_H0033_DELIVERY_ROUTE = "0033";
// 通知区分
export const GC_H0034_NOTIFICATION_TYPE = "0034";
// 取引先制限
export const GC_H0035_VENDOR_LIMIT = "0035";
// 商品荷姿
export const GC_H0036_PRODUCT_PACKAGE = "0036";
// 伝票形式
export const GC_H0037_SLIP_FORMAT = "0037";
// 棚卸商品マスタ登録方法
export const GC_H0038_INVMST_REG_METHOD = "0038";
// 配信ステータス(EDI)
export const GC_H0039_EDI_DELIVERY_STATUS = "0039";
// 配送区分
export const GC_H0040_DELIVERY_TYPE = "0040";
// 祝日区分
export const GC_H0041_HOLIDAY_CLASS = "0041";
// 受払区分
export const GC_H0042_STOCK_IO_CLASS = "0042";
// パターンタイプ区分
export const GC_H0043_PRICE_PATTERN_TYPE = "0043";
// セット商品作成元区分
export const GC_H0044_SET_ITEM_TYPE = "0044";
// 店間移動伝票区分
export const GC_H0045_INTERSTORE_SLIP_TYPE = "0045";
// 伝票取消フラグ
export const GC_H0046_SLIP_CANCEL_FLAG = "0046";
// 返品・値引理由
export const GC_H0047_RET_ALW_REASON = "0047";
// 通知確認フラグ
export const GC_H0048_NOTIF_ACK_FLAG = "0048";
// 予約反映ステータス
export const GC_H0049_RSV_REFLECT_FLAG = "0049";
// エラー種別(納品)
export const GC_H0050_DELIVERY_ERROR_TYPE = "0050";
// 過剰発注チェック区分
export const GC_H0051_EXCESS_ORDER_CHECK = "0051";
// 業務区分(採番用)
export const GC_H0052_SLIP_SEQ_TYPE = "0052";
// 設定区分
export const GC_H0053_SETTING_TYPE = "0053";
// 理論在庫更新フラグ
export const GC_H0054_TH_STOCK_UPD = "0054";
// メーカー親子区分
export const GC_H0055_MAKER_TYPE = "0055";
// 日次集計登録フラグ
export const GC_H0056_DAILY_TOTAL_REG = "0056";
// 売価変更区分
export const GC_H0057_PRICE_CHANGE_TYPE = "0057";
// ドメイン区分
export const GC_H0060_DOMAIN_TYPE = "0060";
// 分類階層
export const GC_H0069_CATEGORY_LEVEL = "0069";
// 最下層フラグ
export const GC_H0071_BOTTOM_FLAG = "0071";
// 管理コード
export const GC_H0072_MGMT_CODE = "0072";
// 指定取引先物流
export const GC_H0073_SPEC_VENDOR_LOG = "0073";
// 発注停止区分
export const GC_H0075_ORDER_STOP_TYPE = "0075";
// 返品区分
export const GC_H0076_RETURN_TYPE = "0076";
// 本部発注停止理由
export const GC_H0077_HQ_CHECK_FLAG = "0077";
// 物流移動可否区分
export const GC_H0078_LOGISTICS_MOVE_FLAG = "0078";
// 原価区分
export const GC_H0079_COST_TYPE = "0079";
// 改廃理由
export const GC_H0080_CHANGE_REASON = "0080";
// 自動発注区分
export const GC_H0082_AUTO_ORDER_TYPE = "0082";
// 自動発注制御
export const GC_H0083_AUTO_ORDER_CTRL = "0083";
// ポイント区分
export const GC_H0085_POINT_TYPE = "0085";
// 発注制限
export const GC_H0090_ORDER_LIMIT = "0090";
// 経費品区分
export const GC_H0091_EXPENSE_ITEM_TYPE = "0091";
// 自動値引禁止
export const GC_H0092_AUTO_DISC_BLOCK = "0092";
// 内容量単位
export const GC_H0093_CAPACITY_UNIT = "0093";
// カラー・サイズコード
export const GC_H0094_COLOR_SIZE_CODE = "0094";
// 形状
export const GC_H0095_SHAPE = "0095";
// 値付
export const GC_H0096_PRICING = "0096";
// 一般用医薬品
export const GC_H0097_OTC_MED = "0097";
// 医薬部外品
export const GC_H0098_QUASI_DRUG = "0098";
// 毒劇薬
export const GC_H0099_POISON_DRUG = "0099";
// 毒劇物
export const GC_H0100_POISON_CHEM = "0100";
// ＬＴ区分
export const GC_H0101_LT_TYPE = "0101";
// 抽出区分
export const GC_H0102_EXTRACT_TYPE = "0102";
// パスワード複雑性
export const GC_H0103_PASS_COMPLEXITY = "0103";
// 権限外データ参照
export const GC_H0104_UNAUTH_DATA_REF = "0104";
// 買掛作成区分
export const GC_H0105_PAYABLE_MAKE_TYPE = "0105";
// 使用不可理由コード
export const GC_H0106_DISABLE_REASON = "0106";
// 活動中フラグ
export const GC_H0107_ACTIVE_FLAG = "0107";
// 職責コード
export const GC_H0108_ROLE_CODE = "0108";
// 属性タイプ
export const GC_H0110_ATTR_TYPE = "0110";
// 登録範囲
export const GC_H0112_REG_RANGE = "0112";
// 委託区分
export const GC_H0113_CONSIGN_TYPE = "0113";
// 指示作成状況
export const GC_H0114_ORDER_CREATE_STAT = "0114";
// 便
export const GC_H0115_DELIV_RUN = "0115";
// 発注締め時間
export const GC_H0116_ORDER_PROC_TIME = "0116";
// 部分棚卸
export const GC_H0117_PARTIAL_INV = "0117";
// 権限
export const GC_H0118_AUTHORITY = "0118";
// POP
export const GC_H0122_POP = "0122";
// 表示店舗条件
export const GC_H0123_STORE_VIEW_COND = "0123";
// 取込ステータス
export const GC_H0125_IMPORT_STATUS = "0125";
// 取込形式
export const GC_H0126_IMPORT_MODE = "0126";
// 管理区分
export const GC_H0128_MGMT_TYPE = "0128";
// 発注用在庫数更新
export const GC_H0129_ORDER_STOCK_UPDATE = "0129";
// 営業中棚卸
export const GC_H0130_LIVE_STOCKTAKE = "0130";
// 棚卸差異要調査条件区分
export const GC_H0132_INV_DIFF_COND = "0132";
// 例外店舗
export const GC_H0136_EXCEPTION_STORE = "0136";
// 更新区分
export const GC_H0137_UPDATE_TYPE = "0137";
// 集計方法
export const GC_H0138_AGGR_METHOD = "0138";
// 配信頻度
export const GC_H0139_DELIVERY_FREQ = "0139";
// 棚卸種別
export const GC_H0140_INV_TYPE = "0140";
// 棚卸状況
export const GC_H0141_INV_STATUS = "0141";
// 棚卸対象受払期間
export const GC_H0146_INV_TARGET_PERIOD = "0146";
// マイメニュー
export const GC_H0150_MY_MENU = "0150";
// サブメニュー
export const GC_H0151_SUB_MENU = "0151";
// 納品実績取込区分
export const GC_H0153_DELIV_IMPORT_TYPE = "0153";
// 伝票状態
export const GC_H0154_SLIP_STATUS = "0154";
// 配信状態
export const GC_H0155_DELIVERY_STATUS = "0155";
// 発注区分
export const GC_H0157_ORDER_TYPE = "0157";
// 伝票区分
export const GC_H0158_SLIP_TYPE = "0158";
// インターフェイス種別
export const GC_H0200_INTERFACE_TYPE = "0200";
// バッチ処理種別
export const GC_H0201_BATCH_PROCESS_TYPE = "0201";
// 文字コード種別
export const GC_H0202_CHARSET_TYPE = "0202";
// 改行コード種別
export const GC_H0203_LINE_FEED_TYPE = "0203";
// 拡張子種別
export const GC_H0204_FILE_EXTENSION_TYPE = "0204";
// 表示フラグ
export const GC_H0205_DISP_FLG = "0205";
// 言語
export const GC_H0490_LANGUAGE = "0490";
// 企画区分
export const GC_H2002_PLAN_TYPE = "2002";
// POS原価使用
export const GC_H2006_POS_COST_USE = "2006";
// 店舗訂正
export const GC_H2008_STORE_EDIT = "2008";
// 販促区分
export const GC_H2009_PROMO_TYPE = "2009";
// 終了タイミング
export const GC_H2011_END_TIMING = "2011";
// 商品コード区分
export const GC_H2012_PRODUCT_CODE_TYPE = "2012";
// ケースセット区分
export const GC_H2013_CASE_SET_TYPE = "2013";
// 属性タイプ
export const GC_H2014_ATTR_TYPE = "2014";
// 赤黒伝票区分
export const GC_H2016_SLIP_CORR_TYPE = "2016";
// 削除
export const GC_H2017_DELETE = "2017";
// ファイル転送タイプ
export const GC_H2019_FILE_TRANS_TYPE = "2019";
// ファイル作成タイプ
export const GC_H2020_FILE_CREATE_TYPE = "2020";
// 接続タイプ
export const GC_H2021_CONNECT_TYPE = "2021";
// 方向タイプ
export const GC_H2022_DIRECTION_TYPE = "2022";
// プロセスタイプ（送信後）
export const GC_H2023_PROCESS_AFTER_SEND = "2023";
// プロセスタイプ（受信後）
export const GC_H2024_PROCESS_AFTER_RECV = "2024";
// エラー分類 (ケース品)
export const GC_H2026_ERROR_TYPE_CASE = "2026";
// 曜日区分
export const GC_H2028_WEEKDAY_TYPE = "2028";
// 配信タイプ
export const GC_H2031_DELIVERY_TYPE = "2031";
// 発注変換フラグ
export const GC_H2034_ORDER_CONV_FLAG = "2034";
// 承認階層
export const GC_H2040_APPROVAL_LEVEL = "2040";
// バッチ処理ステータス
export const GC_H2041_BATCH_PROC_STATUS = "2041";
// バッチ処理起動元
export const GC_H2042_BATCH_LAUNCH_SRC = "2042";
// 活動中フラグ
export const GC_H2043_ACTIVE_FLAG = "2043";
// ＯＳタイプ
export const GC_H2044_OS_TYPE = "2044";
// 金額手数料区分
export const GC_H2047_FEE_AMOUNT_TYPE = "2047";
// 集計区分
export const GC_H2048_AGGR_TYPE = "2048";
// 初回発注入力
export const GC_H2049_FIRST_ORDER_INPUT = "2049";
// 発注停止（店）
export const GC_H2050_ORDER_STOP_STORE = "2050";
// 商品変更区分
export const GC_H2051_PROD_CHANGE_TYPE = "2051";
// 更新操作区分
export const GC_H2052_UPDATE_OP_TYPE = "2052";
// 集計単位
export const GC_H2053_AGGREGATION_UNIT = "2053";
// 商品販売区分
export const GC_H2054_PROD_SALES_TYPE = "2054";
// 買掛締区分
export const GC_H2062_AP_CLOSE_TYPE = "2062";
// 仕入取引伝票区分
export const GC_H2063_PURCHASE_SLIP_TYPE = "2063";
// 請求書取込状況
export const GC_H2065_INVOICE_IMPORT_STAT = "2065";
// 請求照合状況
export const GC_H2066_INVOICE_MATCH_STAT = "2066";
// イベント種別
export const GC_H2068_EVENT_TYPE = "2068";
// デバイス種別
export const GC_H2069_DEVICE_TYPE = "2069";
// 支払保留フラグ
export const GC_H2070_PAYMENT_HOLD_FLAG = "2070";
// 優先方式
export const GC_H2073_PRIORITY_METHOD = "2073";
// 便/回数
export const GC_H2074_DELIV_TIMES = "2074";
// 商品ステータス
export const GC_H2076_PRODUCT_STATUS = "2076";
// 欠品責任区分
export const GC_H2078_STOCKOUT_FAULT = "2078";
// 照合結果
export const GC_H2081_MATCH_RESULT = "2081";
// 申請状態(店間移動)
export const GC_H2083_APPL_STATUS_IST = "2083";
// 店舗承認区分
export const GC_H2084_STORE_APPROVAL_CLASS = "2084";
// 緊急発注区分
export const GC_H2085_URGENT_ORDER_TYPE = "2085";
// 廃棄・振替伝票区分
export const GC_H2086_DISCARD_TRANS_TYPE = "2086";
// 申請状態(廃棄)
export const GC_H2087_APPL_STATUS_DSP = "2087";
